var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.75V3.375C12.0001 2.87772 11.8026 2.40081 11.4509 2.04917C11.0993 1.69754 10.6224 1.5 10.1251 1.5C9.62783 1.5 9.15092 1.69754 8.79929 2.04917C8.44766 2.40081 8.25011 2.87772 8.25011 3.375V14.7437L6.19441 11.1831C6.0714 10.9697 5.90754 10.7825 5.71218 10.6324C5.51683 10.4823 5.29381 10.3722 5.05587 10.3083C4.81793 10.2445 4.56974 10.2281 4.32548 10.2602C4.08122 10.2923 3.84568 10.3723 3.63232 10.4955C3.41897 10.6186 3.23198 10.7827 3.08205 10.9781C2.93211 11.1736 2.82217 11.3967 2.75851 11.6347C2.69485 11.8727 2.67871 12.1209 2.71102 12.3652C2.74333 12.6094 2.82345 12.8449 2.94681 13.0581C6.00011 19.5 7.85798 21.75 12.0001 21.75C12.985 21.75 13.9603 21.556 14.8702 21.1791C15.7802 20.8022 16.607 20.2497 17.3034 19.5533C17.9999 18.8569 18.5523 18.0301 18.9292 17.1201C19.3061 16.2102 19.5001 15.2349 19.5001 14.25V10.5C19.5001 10.0027 19.3026 9.52581 18.9509 9.17417C18.5993 8.82254 18.1224 8.625 17.6251 8.625C17.1278 8.625 16.6509 8.82254 16.2993 9.17417C15.9477 9.52581 15.7501 10.0027 15.7501 10.5",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.5V9.375C15.75 8.87772 15.5525 8.40081 15.2008 8.04917C14.8492 7.69754 14.3723 7.5 13.875 7.5C13.3777 7.5 12.9008 7.69754 12.5492 8.04917C12.1975 8.40081 12 8.87772 12 9.375V9.75",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandTap);
export default __webpack_public_path__ + "static/media/hand-tap.8dba013b71c94315112eb73e19a6cdde.svg";
export { ForwardRef as ReactComponent };